import React, { useEffect, useState } from "react";
import { Map, Marker, InfoWindow } from "@vis.gl/react-google-maps";
import "../../styling/BusinessList.css";
import { ArrowUpRightSquareIcon, ChevronDown, ChevronUp, Filter, MapPin, Phone, SlidersHorizontal } from "lucide-react";
import { HTTP } from "../../api/http-common";
import { useLocation } from "react-router-dom"; // Import useLocation from react-router-dom
import { Link } from "react-router-dom"; // Import Link
import { APIProvider } from "@vis.gl/react-google-maps";
import Tippy from "@tippyjs/react";
import MapView from "../Map/MapView";

const NewBusinesslist = () => {
    const location = useLocation(); // Get the current location
    const queryParams = new URLSearchParams(location.search);
    const [formData, setFormData] = useState({
        city_id: "",
        category_id: "",
    });

    const [cityList, setCityList] = useState([]);
    const [categoriesList, setCategoriesList] = useState([]);
    const [activeVendors, setActiveVendors] = useState([]);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState({
        lat: 34.0489,
        lng: -111.0937,
    }); // Default location
    const access_token = localStorage.getItem("access_token");
    const [totalVendorCount, setTotalVendorCount] = useState([]);
    // console.log("Google Maps API Key:", googleMapsApiKey);
    const [selectedVendor, setSelectedVendor] = useState({});
    const [reloadCount, setReloadCount] = useState(0);
    const [selectedVendorIndex, setSelectedVendorIndex] = useState(null);
    const [locations, setLocations] = useState([]);
    const [filterToggle, setFilterToggle] = useState(false)
    // const [tabFilterToggle, setTabFilterToggle] = useState(false)

    // const handleTabFilterToggle=() =>{
    //     setTabFilterToggle(!tabFilterToggle)
    // }
    const handleFilterToggle =() =>{
        setFilterToggle(!filterToggle)
        // console.log(filterToggle);
        
      }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });

        // setLocations()
        setReloadCount((prev) => prev + 1)
    };

    const fetchCities = async () => {
        try {
            const config = {
                headers: { "Content-Type": "application/json", token: access_token },
            };
            const params = {
                category_id: formData.category_id,
            };

            const response = await HTTP.post("vendors_address/city", params);

            if (response.status === 200) {
                setCityList(response.data); // Assuming response.data contains the list of cities
            }
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };

    // Fetch categories
    const loadCategories = async () => {
        try {
            let fields = {
                filters: {
                    city_id: formData.city_id,
                },
                pagination: { page: "1", limit: "100" },
                sorting: { field: "name", type: "asc" },
            };
            const response = await HTTP.post("/business_cate/list/all", fields);
            if (response.status === 200) {
                setCategoriesList(response.data.contents);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const fetchActiveVendors = async () => {
        try {
            const filters = {

                ...(formData.city_id && { city_id: formData.city_id }),
                ...(formData.category_id && { category_id: formData.category_id }),
                // ...(vendorId && { id: vendorId })
            };

            const response = await HTTP.post("vendors/active_vendor_list", {
                filters,
                pagination: { page: 1, limit: 100 },
                sorting: { field: "first_name", type: "asc" },
            });

            if (response.data) {
                setLocations(response.data.contents || []);
                setActiveVendors(response.data.contents || []);
                setTotalVendorCount(response.data.total_count || 0);
                // setSelectedVendor(response.data.contents);

                // Set the map center to the first vendor's location if available
                if (response.data.contents.length > 0) {
                    const firstVendor = response.data.contents[0];
                    if (firstVendor.latitude && firstVendor.longitude) {
                        setSelectedLocation({
                            lat: firstVendor.latitude,
                            lng: firstVendor.longitude,
                        });
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching vendors:", error);
        }
    };

    const fetchSelectedVendorLocation = async (vendorId) => {
        try {
            const response = await HTTP.post("vendors/active_vendor_list", {
                filters: { id: vendorId },
                pagination: { page: 1, limit: 1 },
            });

            if (response.data.contents.length > 0) {
                const vendor = response.data.contents[0];
                setSelectedVendor(vendor);
                if (vendor.latitude && vendor.longitude) {
                    setSelectedLocation({ lat: vendor.latitude, lng: vendor.longitude });
                }
            }
        } catch (error) {
            console.error("Error fetching selected vendor:", error);
        }
    };

    const clearFilter = () => {
        setFormData({
            city_id: "",
            category_id: "",
        });

        setSelectedVendor(activeVendors);
        setSelectedVendorIndex(null);
        setSelectedMarker(null);
        setSelectedLocation({ lat: 34.0489, lng: -111.0937 });
    };

    const handleMarker = (vendor, index) => {
        if (vendor.locations.length > 0) {
            const { latitude, longitude } = vendor.locations[0];
            setSelectedLocation({ lat: latitude, lng: longitude });
            setSelectedVendor(vendor.id);
            setSelectedVendorIndex(index);
            setSelectedMarker(`${index}-0`);
            fetchSelectedVendorLocation(vendor.id);
        }
    }

    const handleLocation = (vendor, index) => {
        setLocations(vendor);
        setSelectedVendorIndex(index);
    }

    // useEffect(() => {
    //     if (vendorId) {
    //         fetchActiveVendors();
    //     }
    // }, [vendorId]);
    useEffect(()=>{
        const handleResize =() =>{
            if (window.innerWidth>= 1024) {
              setFilterToggle(true)
            } else{
              setFilterToggle(false)
            }
          }
          handleResize()
    },[])

    useEffect(() => {
        fetchActiveVendors();
        fetchCities();
        loadCategories();
    }, [formData]);


    return (
        <div className="flex w-full flex-col md:flex-row">
            {/* Filters Section */}
            {/* <div className={`w-full md:w-1/5 md:h-full ${filterToggle == 1 ?'expand' : 'collapsed'}`}> */}
            <div className={`md:h-full filter-section ${filterToggle == 1 ?'expand' : 'collapsed'}`}>
            {/* ${filterToggle == 1? 'h-[100%] mobile-filter-container opacity-100 ': ' h-[50px]  opacity-0' } */}
            
            <div className={`flex align-items-center justify-between bg-white buiness-list-section-title py-3 px-6   `}>
                <div className="text-center  font-bold ">
                    <p>Filters</p>
                </div>
                <div className="mobile-filter-button" >
              <button onClick={handleFilterToggle}> {filterToggle == 1 ?  <ChevronUp/>: <ChevronDown/>}</button>
            </div>
            </div>
                {/* <div className="business-filter-wrapper"> */}
                <div className={`business-filter-wrapper ${filterToggle == 1 ? 'open' : 'close'}`}>
                    <div className="">
                        <div className="mb-4 drop-down-icon">
                            <label className="sidebar-input-label" htmlFor="category_id">
                                Category
                            </label>
                            {/* Category Filter */}
                            <select
                                name="category_id"
                                value={formData.category_id}
                                onChange={handleChange}
                                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                            >
                                <option value="">Select Category</option>
                                {Array.isArray(categoriesList) && categoriesList.length > 0 ? (
                                    categoriesList.map((category) => (
                                        <option key={category.id} value={category.id}>
                                            {category.name}
                                            (
                                            {category.total_vendor_count}
                                            )
                                        </option>
                                    ))
                                ) : (
                                    <option value="">No categories available</option>
                                )}
                            </select>
                        </div>

                        <div className="mb-4 drop-down-icon">
                            <label className="sidebar-input-label" htmlFor="city_id">
                                City
                            </label>
                            {/* City Filter */}
                            <select
                                name="city_id"
                                value={formData.city_id}
                                onChange={handleChange}
                                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                            >
                                <option value="">Select City</option>
                                {Array.isArray(cityList) && cityList.length > 0 ? (
                                    cityList.map((city) => (
                                        <option key={city.id} value={city.id}>
                                            {city.name} (
                                            {city.total_vendor_count}
                                            )
                                        </option>
                                    ))
                                ) : (
                                    <option value="">No cities available</option>
                                )}
                            </select>
                        </div>
                    </div>

                    <div className="text-center">
                        <button
                            className="block theme-button w-[90%] mx-auto rounded-lg py-2"
                            onClick={fetchActiveVendors}
                        >
                            Search
                        </button>

                        <button
                            className="block w-[90%] mx-auto rounded-lg my-2 bg-gray-200 py-2"
                            onClick={() => clearFilter()}
                        >
                            Clear Filters
                        </button>
                    </div>
                </div>       
            </div>
            
            <div className={`w-full [80%] business-list-filter-section businesses-results ${filterToggle === 1 ? 'expand':'collapsed '}`}>
            {/* filterToggle */}
                {/* <div className="text-center bg-white buiness-list-section-title filter-section font-bold py-3"> */}
                <div className={`text-center bg-white buiness-list-section-title font-bold py-3 `}>
                    <div className="flex items-center justify-between px-6">
                    <span className="tab-filter-wrapper">
                        <button className="theme-button border px-1 py-0.5 rounded-md flex items-center" onClick={handleFilterToggle}>

                            <SlidersHorizontal size={16} />
                            <span className="px-2">
                                    
                            Filters
                            </span>
                        </button>
                    </span>
                    <span>

                    <p>Results found: <span className="theme-color"> {activeVendors.length}</span> </p>
                    </span>
                    </div>
                </div>

                {/* <div className="business-results-wrapper custom-theme-scroll"> */}
                <div className={`business-results-wrapper custom-theme-scroll `}>
                    <div className="flex flex-wrap">

                        {activeVendors.length > 0 ? (
                            activeVendors.map((vendor, index) => (
                                <div key={index} className={`result-business-card-wrapper ${selectedVendorIndex === index ? "border-2 border-blue-500" : ""}`} onClick={() =>handleLocation(vendor, index)}>
                                    <div className="">
                                    {/* onClick={() => handleMarker(vendor, index)} */}
                                    <div className="relative">
                                        <div className="result-business-card-image-wrapper">
                                            <img
                                                src={vendor.main_banner_image}
                                                alt="Vendor"
                                                className=""
                                            />
                                        </div>
                                    </div>
                                    <div className="result-business-card-desc-wrapper">
                                        {/* <h5 className="text-lg font-bold">
                                        {vendor.first_name} {vendor.last_name}
                                    </h5> */}
                                        <Link to={`/vendor/details/${vendor.id}`}>
                                            <span className="flex items-center justify-between cursor-pointer underline">

                                                <span>

                                                    <a className="text-lg font-bold">
                                                        {vendor.business_name}
                                                        {/* {vendor.first_name} {vendor.last_name} */}
                                                    </a>
                                                </span>

                                                {/* <span className="theme-color theme-color-hover-effect">
                                                    <Tippy content="View Profile">
                                                        <Link to={`/vendor/details/${vendor.id}`}>
                                                            <ArrowUpRightSquareIcon className='w-5 h-5' />
                                                        </Link>
                                                    </Tippy>
                                                </span> */}
                                            </span>
                                        </Link>

                                        <div className="business-card-short-description business-list-card-detail-wrapper">
                                        {vendor.short_description && vendor.short_description.length > 50 ?(
                                            <Tippy content={vendor.short_description} placement="bottom">
                                                <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                                  <p className="text-md">{vendor.short_description.substring(0, 50)}...</p>
                                                </div>
                                            </Tippy>
                                        ):(
                                            <p className="text-md">{vendor.short_description}</p>
                                        )}
                                        </div>


                                        {/* <p className="text-sm my-2">{vendor.business_name}</p> */}
                                        <Tippy content="Make a Call" placement="bottom" >
                                            <a href={`tel:${vendor.contact_no || "N/A"} `} className="w-1/2 custom-theme-link-color text-sm text-gray-600 flex items-center hover:text-purple-500">
                                                <Phone className="w-4 h-4 mr-2 theme-color " />{" "}
                                                <span className="" >
                                                    {vendor.contact_no || "N/A"}
                                                </span>
                                            </a>
                                        </Tippy >

                                    </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-gray-600">No vendors available</p>
                        )}
                    </div>
                </div>

            </div>
            {/* <div className="map-wrapper w-[55%]">
                <div className="text-center bg-white buiness-list-section-title font-bold py-3">
                    <p>Location</p>
                </div>
                <MapView
                    selectedLocation={selectedLocation}
                    locations={locations}
                />
            </div> */}
        </div>
    );
};

export default NewBusinesslist;